import { selectStrings } from "../redux/selectors/selectStrings";
import { useAppSelector } from "./useAppSelector";

export function useStrings() {
    return useAppSelector(selectStrings);
}
